// extracted by mini-css-extract-plugin
module.exports = {"avatar":"avatar_avatar__7FJXL","avatar_wrap":"avatar_avatar_wrap__ptiEG","avatar_vip":"avatar_avatar_vip__7Rep_","avatar_vip_p":"avatar_avatar_vip_p__u8wCV"};